var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMens1FourthZip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5478 12.7269C21.8448 12.4099 20.5508 10.9429 20.4968 9.15892C20.4868 9.11892 20.4668 9.08492 20.4578 9.04492H17.0808L17.1008 9.06592C17.1008 9.06592 16.0598 9.03192 15.1868 9.68192C14.3128 10.3309 14.0588 11.0579 13.9908 11.2819C13.9888 11.2909 13.9698 11.2879 13.9618 11.2939L13.8308 11.6519V11.6529L4.42578 37.4039L9.84278 38.8549L12.6848 31.0549L12.6868 31.0509L13.8308 27.9109V28.0139L16.7518 20.2609V36.2289H22.5588H22.9238H23.5488V12.7269H23.5478Z",
    fill: "#A6A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2279 13.8789L34.2979 11.3449C34.2609 11.3199 34.2299 11.2869 34.2159 11.2399C34.0969 10.8279 33.5519 9.9819 32.8679 9.5699C32.1819 9.1579 31.1199 9.0669 31.1199 9.0669L31.1899 9.0459H27.9849C27.9849 10.9819 26.5119 12.5559 24.6309 12.7559V18.6244L22.6309 18.4929V36.2299H25.2559H25.8189H31.5969L31.6459 20.2039L35.6869 31.5839L38.2359 38.5829L38.3359 38.9549L43.7539 37.5039L35.2279 13.8789Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMens1FourthZip);
export default __webpack_public_path__ + "static/media/mens_1fourth_zip.6c92f0fb4abfc6760cb9668842bd7b97.svg";
export { ForwardRef as ReactComponent };